.count {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  padding: 0.0625rem var(--space-2);
  border-radius: var(--radius-full);
  background-color: var(--color-surface-2);
  color: var(--color-text-muted);
}

/* Tabs */
.tabs {
  display: flex;
  gap: var(--space-2);
  border-bottom: 1px solid var(--color-border);
  overflow-x: auto;
  scrollbar-width: none;
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: var(--control-height-md);
  padding: 0 var(--space-3);
  margin-bottom: -1px;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-muted);
  white-space: nowrap;
}

.tab:hover {
  color: var(--color-text);
}

.tabSelected {
  border-bottom-color: var(--color-accent);
  color: var(--color-text);
}

/* Segmented control */
.segments {
  display: inline-flex;
  gap: var(--space-1);
  padding: var(--space-1);
  border-radius: var(--radius-md);
  background-color: var(--color-surface-2);
  border: 1px solid var(--color-border);
}

.segment {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: calc(var(--control-height-md) - var(--space-3));
  padding: 0 var(--space-4);
  border: none;
  border-radius: var(--radius-sm);
  background: none;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-muted);
  white-space: nowrap;
}

.segment:hover {
  color: var(--color-text);
}

.segmentSelected {
  background-color: var(--color-surface);
  color: var(--color-text);
  box-shadow: var(--shadow-sm);
}

.segmentSelected .count {
  background-color: var(--color-accent-soft);
  color: var(--color-accent-text);
}

/* Filter chips */
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: var(--control-height-sm);
  padding: 0 var(--space-4);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-full);
  background-color: var(--color-surface);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-2);
  white-space: nowrap;
}

.chip:hover {
  color: var(--color-text);
  border-color: var(--color-text-muted);
}

.chipSelected,
.chipSelected:hover {
  background-color: var(--color-text);
  border-color: var(--color-text);
  color: var(--color-bg);
}

.chipSelected .count {
  background-color: var(--color-accent);
  color: var(--color-on-accent);
}
